import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { STORAGE_KEYS, captureOrgId, captureTxnId, redirectUrlLogin } from "./common";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

// Cross-tab sign-out sync: when the signed-in user is cleared in another tab,
// redirect the current tab to the login page (keeps the tsf-pittouch pattern).
window.addEventListener(
  "storage",
  (event) => {
    if (event.storageArea === localStorage && !localStorage.getItem(STORAGE_KEYS.userInfo)) {
      redirectUrlLogin();
    }
  },
  false
);

// Capture the Salesforce params (?org_id=...&txn_id=...) as early as possible, before
// React Router can navigate and drop the query string.
captureOrgId();
captureTxnId();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter>
    <ToastContainer position="top-right" autoClose={5000} hideProgressBar theme="light" />
    <App />
  </BrowserRouter>
);

reportWebVitals();
